/**
 * Tipos de evento de dominio de la tienda (adapter store).
 *
 * Son los `type` que viajan en el envelope genérico. El enriquecimiento
 * (productId, points, etc.) va en `properties`. `balancePoints` (atPoints)
 * lo aporta el bridge via `setBaseProperties` desde `availablePoints`.
 */
export const StoreEventTypes = {
  // Descubrimiento
  VIEW_PRODUCT: 'view_product',
  QUICK_VIEW_PRODUCT: 'quick_view_product',
  VIEW_CATEGORY: 'view_category',
  VIEW_SUBCATEGORY: 'view_subcategory',
  SEARCH: 'search',
  VIEW_PROMOTION: 'view_promotion',

  // Listados
  CLICK_MORE_FEATURED: 'click_more_featured',
  CLICK_MORE_MOST_REDEEMED: 'click_more_most_redeemed',
  CLICK_MORE_REACHABLE: 'click_more_reachable',
  CLICK_MORE_FROM_CATEGORY: 'click_more_from_category',

  // Wishlist
  ADD_TO_WISHLIST: 'add_to_wishlist',
  REMOVE_FROM_WISHLIST: 'remove_from_wishlist',

  // Carrito
  ADD_TO_CART: 'add_to_cart',
  REMOVE_FROM_CART: 'remove_from_cart',
  UPDATE_CART_QUANTITY: 'update_cart_quantity',
  VIEW_CART: 'view_cart',

  // Checkout / canje
  BEGIN_CHECKOUT: 'begin_checkout',
  REDEEM: 'redeem',
  REDEEM_FAILED: 'redeem_failed',
  POINTS_INSUFFICIENT: 'points_insufficient',

  // Cuenta
  VIEW_MY_REQUESTS: 'view_my_requests',
  VIEW_ACCOUNT_BALANCE: 'view_account_balance',
} as const;

export type StoreEventType = (typeof StoreEventTypes)[keyof typeof StoreEventTypes];
